export default function activeFiltersCount(filters: any): number {
    return Object.entries(filters || {}).reduce((count, [key, value]) => {
        if (key === 'name' && value) {
            return count + 1
        }
        if (Array.isArray(value) && value.length > 0) {
            return count + 1
        }
        if (typeof value === 'string' && value && value !== '') {
            return count + 1
        }
        return count
    }, 0)
}
